<template>
    <div class="white-wrapper">
        <main class="container">
            <div class="main">
                <img src="../assets/sub_page_images/main-image.jpeg">

                <div class="main__wrapper">
                    <div class="main__documentary-watch-button">
                        <div class="main__documentary-watch-button-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                 width="29" height="29" viewBox="0 0 29 29">
                                <defs>
                                    <filter id="prefix__a" width="114.8%" height="114.8%" x="-7.4%" y="-3.7%"
                                            filterUnits="objectBoundingBox">
                                        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1"/>
                                        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1"
                                                        stdDeviation=".5"/>
                                        <feColorMatrix in="shadowBlurOuter1"
                                                       values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"/>
                                    </filter>
                                    <path id="prefix__b"
                                          d="M39.498 15C32.043 15 26 21.044 26 28.5c0 7.454 6.044 13.499 13.498 13.499 7.455 0 13.498-6.045 13.498-13.499 0-7.456-6.043-13.5-13.498-13.5zM36.8 33v-9.007l8.017 4.504L36.801 33z"/>
                                </defs>
                                <g fill="none" fill-rule="evenodd" transform="translate(-25 -15)">
                                    <use fill="#000" filter="url(#prefix__a)" xlink:href="#prefix__b"/>
                                    <use fill="#FFF" xlink:href="#prefix__b"/>
                                </g>
                            </svg>
                        </div>
                        <a href="https://www.youtube.com/watch?v=AXq2o4iHTzQ" target="_blank"
                           class="main__documentary-watch-button-text">BELGESELİ İZLE</a>
                    </div>
                </div>
            </div>
            <div class="interview">
                <div class="interview__wrapper">
                    <div class="interview__left">
                        <h1 class="interview__title">Her gün sadece 25 litre su ile yaşamak zorunda olduğunuzu düşünün.</h1>
                        <span class="interview__description">
                        Su krizi, dünyanın en büyük metropollerini tehdit ediyor. 25 Litre belgeseli;
                        geleceğin İstanbul’unda olası bir susuzluğu ele alırken, günümüzde bu karanlık tabloyu
                        değiştirmenin yollarını Gökhan Özoğuz rehberliğinde arıyor.
                    </span>
                    </div>
                    <div class="interview__right">
                        <div class="interview__right-wrapper">
                            <carousel :autoplay="false" :nav="false" :dots="false" :items=1 :stagePadding=0 :margin=0>

                                <div class="interview__item">
                                    <div class="interview__image">
                                        <img src="../assets/sub_page_images/group-3@2x.png">
                                    </div>
                                    <div class="interview__quotation">
                                        <div class="interview__quotation-text">
                                            <span>“Son araştırmalar, günümüzdeki birkaç onyıl içerisinde yüz milyondan fazla insanın iklim mültecisi olacağını söylüyor.”</span>
                                            <span>DR. ÖMER MADRA<br> Araştırmacı Yazar ve Radyo Programcısı</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="interview__item">
                                    <div class="interview__image">
                                        <img src="../assets/sub_page_images/group-3@2x.png">
                                    </div>
                                    <div class="interview__quotation">
                                        <div class="interview__quotation-text">
                                            <span>Test-1</span>
                                            <span>Test-1<br> Araştırmacı Yazar ve Radyo Programcısı</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="interview__item">
                                    <div class="interview__image">
                                        <img src="../assets/sub_page_images/group-3@2x.png">
                                    </div>
                                    <div class="interview__quotation">
                                        <div class="interview__quotation-text">
                                            <span>Test-2</span>
                                            <span>Test-2<br> Araştırmacı Yazar ve Radyo Programcısı</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="interview__item">
                                    <div class="interview__image">
                                        <img src="../assets/sub_page_images/group-3@2x.png">
                                    </div>
                                    <div class="interview__quotation">
                                        <div class="interview__quotation-text">
                                            <span>Test-3</span>
                                            <span>Test-3<br> Araştırmacı Yazar ve Radyo Programcısı</span>
                                        </div>
                                    </div>
                                </div> -->

                            </carousel>

                            <div class="interview__buttons">
                                <div class="interview__prev-button" v-on:click="owlPrevInterView">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58 58">
                                        <path d="M.113 28.859c0 15.738 12.762 28.5 28.5 28.5s28.5-12.762 28.5-28.5-12.762-28.5-28.5-28.5-28.5 12.762-28.5 28.5zm34.258.016l-9.402 9.363-1.41-1.418 8.003-7.973-8.02-8.293 1.438-1.39 9.391 9.71z"/>
                                    </svg>
                                </div>
                                <div class="interview__next-button" v-on:click="owlNextInterView">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58 58">
                                        <path d="M.113 28.859c0 15.738 12.762 28.5 28.5 28.5s28.5-12.762 28.5-28.5-12.762-28.5-28.5-28.5-28.5 12.762-28.5 28.5zm34.258.016l-9.402 9.363-1.41-1.418 8.003-7.973-8.02-8.293 1.438-1.39 9.391 9.71z"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="documentary">
                <div class="documentary__wrapped">
                    <iframe width="100%" height="625" src="https://www.youtube.com/embed/AXq2o4iHTzQ" frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                </div>
            </div>
            <div class="short-videos">
                <div class="short-videos__wrapper">
                    <div class="short-videos__big-title">
                        <span>Belgeselden Kısa Kısa</span>
                    </div>
                    <div class="short-videos__container">
                        <a data-fancybox="gallery" href="https://www.youtube.com/watch?v=ZbTCMcnd1Ls">
                            <div class="short-videos__item">
                                <div class="short-videos__image">
                                    <img src="../assets/sub_page_images/video-1-bg.jpg">
                                    <div class="short-videos__play-icon">
                                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="play"
                                             class="svg-inline--fa fa-play fa-w-14" role="img"
                                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                            <path fill="currentColor"
                                                  d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div class="short-videos__description">
                                    <span>Her gün 25 litre suyla yaşamak zorunda olduğunuzu düşünün... 25 Litre belgeseli National Geographic'te!</span>
                                </div>
                            </div>
                        </a>
                        <a data-fancybox="gallery" href="https://www.youtube.com/watch?v=sSnZoTFBVIM">
                            <div class="short-videos__item">
                                <div class="short-videos__image">
                                    <img src="../assets/sub_page_images/video-2-bg.jpg">
                                    <div class="short-videos__play-icon">
                                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="play"
                                             class="svg-inline--fa fa-play fa-w-14" role="img"
                                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                            <path fill="currentColor"
                                                  d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div class="short-videos__description">
                                    <span>Gökhan Özoğuz'u Türkiye'nin suyunu korumak ile ilgili harekete geçiren ne oldu?</span>
                                </div>
                            </div>
                        </a>
                        <a data-fancybox="gallery" href="https://www.youtube.com/watch?v=2k1Gda7O9dw">
                            <div class="short-videos__item">
                                <div class="short-videos__image">
                                    <img src="../assets/sub_page_images/video-3-bg.jpg">
                                    <div class="short-videos__play-icon">
                                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="play"
                                             class="svg-inline--fa fa-play fa-w-14" role="img"
                                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                            <path fill="currentColor"
                                                  d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div class="short-videos__description">
                                    <span>Gökhan Özoğuz, 25 litre suyla bir gün geçirmenin nasıl bir deneyim olduğunu anlatıyor.</span>
                                </div>
                            </div>
                        </a>
                        <a data-fancybox="gallery" href="https://www.youtube.com/watch?v=o6N-McahQ74">
                            <div class="short-videos__item">
                                <div class="short-videos__image">
                                    <img src="../assets/sub_page_images/video-4-bg.jpg">
                                    <div class="short-videos__play-icon">
                                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="play"
                                             class="svg-inline--fa fa-play fa-w-14" role="img"
                                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                            <path fill="currentColor"
                                                  d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div class="short-videos__description">
                                    <span>Özge Özpirinçci'yi 25 Litre belgeselinde yer almaya iten neydi? Özge Özpirinçci'nin 25 Litre belgeselinde yer alma kararını dinliyoruz.</span>
                                </div>
                            </div>
                        </a>
                        <a data-fancybox="gallery" href="https://www.youtube.com/watch?v=OCzeXChC5LU">
                            <div class="short-videos__item">
                                <div class="short-videos__image">
                                    <img src="../assets/sub_page_images/video-5-bg.jpg">
                                    <div class="short-videos__play-icon">
                                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="play"
                                             class="svg-inline--fa fa-play fa-w-14" role="img"
                                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                            <path fill="currentColor"
                                                  d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div class="short-videos__description">
                                    <span>National Geographic'te yayınlanan 25 Litre belgeselinin ardından Özge Özpirinçci suyun öneminden bahsediyor.</span>
                                </div>
                            </div>
                        </a>
                        <a data-fancybox="gallery" href="https://www.youtube.com/watch?v=DNuUBKdvcHA">
                            <div class="short-videos__item">
                                <div class="short-videos__image">
                                    <img src="../assets/sub_page_images/video-6-bg.jpg">
                                    <div class="short-videos__play-icon">
                                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="play"
                                             class="svg-inline--fa fa-play fa-w-14" role="img"
                                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                            <path fill="currentColor"
                                                  d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div class="short-videos__description">
                                    <span>Özge Özpirinçci, National Geographic ve belgeseller hakkında ne hissediyor?</span>
                                </div>
                            </div>
                        </a>
                        <a data-fancybox="gallery" href="https://www.youtube.com/watch?v=afUODXEGz-A&t=4s">
                            <div class="short-videos__item">
                                <div class="short-videos__image">
                                    <img src="../assets/sub_page_images/video-7-bg.jpg">
                                    <div class="short-videos__play-icon">
                                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="play"
                                             class="svg-inline--fa fa-play fa-w-14" role="img"
                                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                            <path fill="currentColor"
                                                  d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div class="short-videos__description">
                                    <span>Gerekli önlemler alınmazsa Cape Town'da yaşanan su krizinin benzeri Türkiye'de de yaşanabilir. Özge Özpirinçci Cape Town'da yaşadıklarını anlatıyor.</span>
                                </div>
                            </div>
                        </a>
                        <a data-fancybox="gallery" href="https://www.youtube.com/watch?v=HSi2lFRH3zM&t=6s">
                            <div class="short-videos__item">
                                <div class="short-videos__image">
                                    <img src="../assets/sub_page_images/video-8-bg.jpg">
                                    <div class="short-videos__play-icon">
                                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="play"
                                             class="svg-inline--fa fa-play fa-w-14" role="img"
                                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                            <path fill="currentColor"
                                                  d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div class="short-videos__description">
                                    <span>Başta 25 litre suyla günü geçirebileceğini düşünen Özge Özpirinçci'nin fikrini değiştiren ne oldu?</span>
                                </div>
                            </div>
                        </a>
                        <a data-fancybox="gallery" href="https://www.youtube.com/watch?v=OGW6TDN8Wuk">
                            <div class="short-videos__item">
                                <div class="short-videos__image">
                                    <img src="../assets/sub_page_images/video-9-bg.jpg">
                                    <div class="short-videos__play-icon">
                                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="play"
                                             class="svg-inline--fa fa-play fa-w-14" role="img"
                                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                            <path fill="currentColor"
                                                  d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div class="short-videos__description">
                                    <span>Yakın gelecekte sadece 25 litre su ile yaşamak zorunda kalabiliriz.</span>
                                </div>
                            </div>
                        </a>
                        <a data-fancybox="gallery" href="https://www.youtube.com/watch?v=EKBSccY_ioc">
                            <div class="short-videos__item">
                                <div class="short-videos__image">
                                    <img src="../assets/sub_page_images/video-10-bg.jpg">
                                    <div class="short-videos__play-icon">
                                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="play"
                                             class="svg-inline--fa fa-play fa-w-14" role="img"
                                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                            <path fill="currentColor"
                                                  d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div class="short-videos__description">
                                    <span>Türkiye'yi çok ciddi bir kuraklık bekliyor.</span>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            <div class="other-videos">
                <div class="other-videos__wrapper">
                    <div class="other-videos__item">
                        <div class="other-videos__video-title">
                            <span>25 Litre İle Bir Gün Geçirmek - Uras Benlioğlu</span>
                        </div>
                        <div class="other-videos__video">
                            <iframe class="other-video-item" src="https://www.youtube.com/embed/oEydlSDBj7Q?rel=0"
                                    frameborder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen=""></iframe>
                        </div>
                    </div>
                    <div class="other-videos__item">
                        <div class="other-videos__video-title">
                            <span>25 Litre İle Bir Gün Geçirmek - Ruhi Çenet</span>
                        </div>
                        <div class="other-videos__video">
                            <iframe class="other-video-item" src="https://www.youtube.com/embed/YJ8P2ye0ax0?rel=0"
                                    frameborder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen=""></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import EventBus from "../main";
import carousel from 'vue-owl-carousel';


export default {
        name: "Documentary25Litre",
        components: {carousel},
        methods: {
            owlPrevInterView: function (event) {
                $('.interview__right-wrapper > div > .owl-carousel > .owl-nav > .owl-prev').click();
            },
            owlNextInterView: function (event) {
                $('.interview__right-wrapper > div > .owl-carousel > .owl-nav > .owl-next').click();
            }
        },
        mounted() {
            EventBus.$emit('menu-status', false);
            this.$store.commit('navigationStatus', 'subPage');
        }
    }
</script>

<style lang="scss" scoped>
    $base-width: 1140px;
    $icon-font: "Font Awesome 5 Free";

    .white-wrapper {

        background-color: white;
        width: 100%;

        .container {
            width: initial;
            overflow: hidden;
        }
    }

    .container {
      padding-top: 0px !important;
      padding-left: initial !important;
    }

    .main {

        background-color: lightgrey;
        width: 100%;
        height: auto;
        display: flex;
        position: relative;

        > img {
            min-width: 100vw;
            width: 100vw;
        }

        &__image {
            height: auto;
            width: 100%;

            > img {
                width: 100%;
            }
        }

        &__wrapper {
            width: $base-width;
            margin: 0 auto;
            display: flex;

            @media (max-device-width: 768px) {
                width: 90%;
            }
        }

        &__documentary-watch-button {
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            width: 245px;
            height: 57px;
            border-radius: 28.5px;
            box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.22);
            background-image: linear-gradient(to top, #00a0e2, #00c3ee);
            right: 240px;
            bottom: 37px;
            position: absolute;
            transition: all 0.5s;

            &:hover {

                transform: scale(1.2);
            }

            @media (max-device-width: 768px) {
                bottom: -45px;
                right: 0px;
                left: 0px;
                margin: 0px auto;

                width: 435px;
                height: 90px;
                border-radius: 48.5px;
            }
        }

        &__documentary-watch-button:hover {

            > .main__documentary-watch-button-text {
                color: white;
                text-decoration: none;
            }
        }

        &__documentary-watch-button-icon {
            font-size: 27px;
            color: white;
            display: flex;
            margin-right: 25px;
        }

        &__documentary-watch-button-text {
            color: white;
            font-weight: bold;
            font-size: 14px;
            text-decoration: none;
            @media (max-device-width: 768px) {
                font-size: 30px;
            }
        }

    }

    .interview {
        height: 630px;

        @media (max-device-width: 768px) {
            height: auto;
            margin-top: 100px;
        }

        &__wrapper {
            width: 1140px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 65px auto;

            @media (max-device-width: 768px) {
                width: 90%;
                flex-direction: column;
            }
        }


        &__left {
            display: flex;
            flex-direction: column;
            width: 60%;

            @media (max-device-width: 768px) {
                width: 100%;
            }
        }

        &__title {
            color: black;
            font-size: 45px;
            font-weight: bold;
            line-height: 1.33;
        }

        &__description {
            font-size: 14px;
            font-weight: bold;
            margin-top: 30px;
            line-height: 1.79;
            color: black;
        }

        &__right {
            display: flex;
            width: 35%;
        }

        &__right-wrapper {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;

            @media (max-device-width: 768px) {
                margin-top: 100px;
            }

            & > div > .owl-carousel > .owl-stage-outer {
                width: 421px;
                @media (max-device-width: 768px) {
                    width: 800px;
                }
            }


        }

        &__image {
            width: 303px;

            > img {
                width: 100%;
                border-radius: 50%;
            }

            @media (max-device-width: 768px) {
                width: 80%;
            }
        }

        &__quotation {
            width: 420px;
            height: 142px;
            background-color: black;
            color: white;
            margin-top: -30px;

            @media (max-device-width: 768px) {
                width: 100%;
                height: auto;
            }
        }

        &__quotation-text {
            display: flex;
            flex-direction: column;
            text-align: center;
            justify-content: space-between;
            padding: 23px 0 33px 0;


            > span:nth-child(1) {
                font-size: 14px;
                @media (max-device-width: 768px) {
                    font-size: 33px;
                }
            }

            > span:nth-child(2) {
                font-size: 13px;
                font-weight: bold;
                @media (max-device-width: 768px) {
                    font-size: 23px;
                    margin-top: 30px;
                }
            }

            @media (max-device-width: 768px) {
                padding: 50px 50px;
                font-size: 35px;
            }
        }

        &__buttons {
            display: flex;
        }

        &__next-button {
            width: 57px;
            cursor: pointer;

            > svg {
                width: 100%;
            }

            @media (max-device-width: 768px) {
                width: 100px;
            }
        }

        &__prev-button {
            cursor: pointer;
            width: 57px;
            margin-right: 26px;
            transform: rotate(180deg);
            margin-top: -5px;

            > svg {
                width: 100%;
                margin-top: 3px;
            }

            @media (max-device-width: 768px) {
                width: 100px;
            }
        }

        &__item {
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    }

    .documentary {
        height: auto;

        &__wrapped {
            width: $base-width;
            margin: 0 auto;

            @media (max-device-width: 768px) {
                width: 90%;
                grid-template-columns: 100%;

                & > iframe {
                    height: 500px;
                }
            }
        }
    }

    .short-videos {

        &__wrapper {
            width: $base-width;
            margin: 60px auto;


            @media (max-device-width: 768px) {
                width: 90%;
            }
        }

        &__big-title {
            font-size: 25px;
            font-weight: bold;
            text-align: center;
        }

        &__container {
            display: grid;
            margin-top: 40px;
            width: 100%;
            grid-template-columns: 550px 550px;
            column-gap: 40px;
            row-gap: 40px;

            > a {
                text-decoration: none;
            }


            @media (max-device-width: 768px) {
                grid-template-columns: 100%;
            }
        }

        &__image {
            width: 50%;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;

            > img {
                width: 100%;
            }

            @media (max-device-width: 768px) {
                width: 100%;
            }
        }

        &__play-icon {
            position: absolute;
            width: 30px;
            color: white;
        }

        &__item {
            display: flex;
            background-color: black;
            cursor: pointer;

            > img {
                width: 100%;
            }

            @media (max-device-width: 768px) {
                flex-direction: column;
            }
        }

        &__description {
            width: 50%;
            padding: 25px;
            color: white;
            font-size: 15px;
            display: flex;
            align-items: center;
            @media (max-device-width: 768px) {
                width: 100%;
                font-size: 35px;
                padding: 40px 40px;
            }
        }
    }

    .other-videos {
        height: 400px;
        margin-top: 90px;


        @media only screen and (max-device-width: 768px) {
            height: auto;
        }

        &__wrapper {
            width: $base-width;
            margin: 0 auto;
            display: grid;
            grid-template-columns: 550px 550px;
            column-gap: 40px;
            row-gap: 40px;

            @media (max-device-width: 768px) {
                width: 90%;
                grid-template-columns: 100%;
                margin-bottom: 50px;
            }
        }

        &__video-title {
            font-weight: bold;
            font-size: 15px;
            color: black;
            text-align: center;
            margin-bottom: 20px;

            @media (max-device-width: 768px) {
                width: 100%;
                font-size: 45px;
            }
        }


    }

    .other-video-item {
        width: 100%;
        height: 200px;

        @media (max-device-width: 768px) {
            height: 500px;
        }
    }


</style>
